var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-triangle',{attrs:{"type":_vm.polygonalChartType,"data":_vm.data,"alarmed":_vm.alarmed,"coordinates":_vm.triangleCoordinates}})}
var staticRenderFns = []

export { render, staticRenderFns }